<mat-toolbar color="primary">
  @if (menuEnabled) {
    <button
      mat-icon-button
      (click)="onMenuClick()">
      <mat-icon>menu</mat-icon>
    </button>
  }
</mat-toolbar>
